export default {
  presenter: 'hodac',
  title: 'Vim na 20 min',
  subtitle: 'začátečníci',
  text: `
Základy textového editoru Vim za 20 min nejen jako základ pro workshop.
  `,
}



// WEBPACK FOOTER //
// ./src/content/installfest/data/presentations/hodac-vim.js